const Image = () => {
    return (
        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.01172 6.43945C8.01172 7.54455 7.11681 8.43945 6.01172 8.43945C4.90771 8.43945 4.01172 7.54455 4.01172 6.43945C4.01172 5.33436 4.90771 4.43945 6.01172 4.43945C7.11573 4.44054 8.01064 5.33544 8.01172 6.43945Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17 13C16.2598 12.3474 14.3363 10.5 12.7885 10.5C11.2399 10.5 10.3473 13.4077 8.85802 13.4077C7.36876 13.4077 6.01584 12.0929 4.82251 12.9358C3.62917 13.7779 2 16.5 2 16.5"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x="0.75"
                y="1.25"
                width="16.5"
                height="16.5"
                rx="2.25"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default Image
